<template>
  <div data-component="base-search-query">
    <component
      :is="getComponentType(param)"
      v-for="param in query"
      :key="param.key"
      :param="param"
      :schema="schema"
      @delete-param="$emit('delete-param', param)"
    />

    <!-- Add an input here so it would wrap together with query params -->
    <slot name="input" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import BaseSearchQueryStringValue from './BaseSearchQueryStringValue.vue';
import BaseSearchQueryDateRangeValue from './BaseSearchQueryDateRangeValue.vue';
import BaseSearchQueryLabels from './BaseSearchQueryLabels.vue';
import { QueryParam } from '../../types';
import { useSearch } from '../../composables';
import { QUERY_PROP, SCHEMA_PROP, QUERY_PARAM_TYPE } from '../../constants';

export default defineComponent({
  name: 'BaseSearchQuery',
  props: {
    query: QUERY_PROP,
    schema: SCHEMA_PROP,
  },
  emits: ['delete-param'],
  setup(props) {
    const { schemaAsMap } = useSearch(props);
    return { schemaAsMap };
  },
  methods: {
    getComponentType(param: QueryParam) {
      const schemaItem = this.schemaAsMap[param.key];

      switch (schemaItem.type) {
        case QUERY_PARAM_TYPE.STRING:
          return BaseSearchQueryStringValue;
        case QUERY_PARAM_TYPE.DATE_RANGE:
          return BaseSearchQueryDateRangeValue;
        case QUERY_PARAM_TYPE.OBJECT:
        default:
          return BaseSearchQueryLabels;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-search-query'] {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s-2);
  overflow: hidden;
}
</style>
